define((require) => {
    "use strict";

    const {extend, map, clone}  = require("underscore");
    const ViewController        = require("editor/util/ViewController");
    const ChannelPropertiesView = require("ui/publish/channelSetup/ChannelPropertiesView");
    const Channel               = require("ui/publish/channelSetup/Channel");
    const Lightbox              = require("shared/ui/common/Lightbox");
    const LoggedIn              = require("shared/security/LoggedIn");
    const Time                  = require("shared/services/Time");
    const PublishUtil           = require("ui/publish/PublishUtil");

    /**
     * View Controller of a channel item view.
     *
     */
    return ViewController.extend({
        /**
         * Triggered when the user has clicked on an row for a given channel to edit. <p>
         *
         * <tt>field</tt> will be the class name of the target element clicked in the row, e.g. "next-experience"
         * if the title of the Experience scheduled to go live next was clicked.
         *
         * @param {String}  property The channel property the user clicked on to gain focus now, if any, e.g.
         *                           "name", or "experience". Can be falsey, i.e. just open view without focus.
         */
        onViewEditOpened(property) {
            const realChannel = this.model;
            const tmpChannelOptions = realChannel.pick("name", "selector", "url", "id", "experience", "group", "publishable");

            extend(tmpChannelOptions, {
                schedules: map(realChannel.get("schedules"), clone)
            });

            const tmpChannel = new Channel(tmpChannelOptions);

            let selectedLiveModel;
            let selectedScheduledModel;

            if (realChannel.hasLive()) {
                selectedLiveModel = realChannel.get("publishable");
            }

            if (realChannel.hasSchedule()) {
                const schedule = realChannel.getFirstSchedule();
                if (schedule.takeDownCurrent) {
                    selectedScheduledModel = PublishUtil.NO_EXPERIENCE_SCHEDULED;
                } else {
                    selectedScheduledModel = schedule.publishable;
                }
            }

            this._openChannelSlotLightbox(realChannel, tmpChannel, property, selectedLiveModel, selectedScheduledModel);
        },

        _openChannelSlotLightbox(realChannel, tmpChannel, property, selectedLiveModel, selectedScheduledModel) {
            const {publishableDescriptors, publishableCollection, projectContext} = this.options;
            const channelPropertiesView = new ChannelPropertiesView({
                parentView: this.view,
                model: tmpChannel,
                isNewSlot: false,
                focus: property,
                selectedLiveModel,
                selectedScheduledModel,
                publishableDescriptors,
                publishableCollection,
                projectContext,
                allowedToPublish: this.view._allowedToPublish

            });

            channelPropertiesView.once("done", (channel) => {
                const principal = LoggedIn.principal();
                channel.set({
                    editedBy: principal.get("userId"),
                    companyId: principal.get("companyId"),
                    editedAt: Time.server(),
                    version:  realChannel.get("version")
                });

                realChannel.set(channel.attributes);

                // Can still be dnd...
                const manual = !!realChannel.get("manual");
                let attribute;

                if (!manual) {
                    // Ignore "editedAt" and "editedBy"...
                    for (attribute in realChannel.changed) {
                        if (attribute !== "editedAt" && attribute !== "editedBy") {
                            realChannel.set("manual", true);
                            break;
                        }
                    }
                }

                this.options.parentView.trigger("handleChanges", "update", realChannel);
            });

            const options = {
                css: {
                    width: 830
                },
                editorEventProperties: {
                    modalType: "ChannelSlotProperties",
                    triggerOrigin: "ExistingChannelSlotModal",
                    isNewSlot: false
                }
            };

            const box = new Lightbox(channelPropertiesView, options);

            box.open();
        }
    });
});



// WEBPACK FOOTER //
// ./src/editor/ui/publish/channelSetup/ChannelSetupItemViewController.js